import type {FunctionComponent} from 'react';
import {useArtistremunerationData} from '@app/modules/ssg-data/artist-remuneration/client';
import {PlaylistSection} from '@app/views/generic';
import {useAsRailItems} from '@app/modules/ssg-data/utils';

export const MoodRail: FunctionComponent = () => {
	const {playlistAsRailItem} = useAsRailItems();
	const {data} = useArtistremunerationData();

	return (
		<PlaylistSection
			playlistItems={playlistAsRailItem(data?.playlists.edges)}
		/>
	);
};
